export enum CompsIntegrationEnum {
  None = 0,
  Sale = 1,
  Lease = 2,
  IE = 3,
  All = 4
}
